export const Urls = {
  DISCORD_URL: 'https://discord.com/invite/gk25cyBs78',
  ALICE_URL: 'https://alice.society.xyz/',
  ALICE_OPENSEA_URL: 'https://opensea.io/collection/slash-alice-nft',
  ALICE_ELEMENT_MARKET_URL: 'https://element.market/collections/slash-alice-nft',
  ALICE_TWITTER_URL: 'https://x.com/SocietyFdn',
  OPENSEA_URL: 'https://opensea.io',
};
